// 다른 방법으로 문의 — 카카오톡 채널(옛 헤더 '실시간 상담' 자리에서 옮겨 옴)·전화
export const KAKAO_CHANNEL_ID = '_AsExjC';
export const PHONE_NUMBER = '02-1588-5480';

export function openKakaoChannel() {
  const K = window.Kakao;
  try {
    if (K && K.Channel && (K.isInitialized ? K.isInitialized() : true)) {
      K.Channel.chat({ channelPublicId: KAKAO_CHANNEL_ID });
      return;
    }
  } catch (e) { /* SDK 없음 — 아래 링크로 */ }
  window.open(`https://pf.kakao.com/${KAKAO_CHANNEL_ID}/chat`, '_blank', 'noopener');
}

export function callPhone() {
  window.location.href = `tel:${PHONE_NUMBER.replace(/-/g, '')}`;
}
